export function buildLoginUrl(redirectPath: string): string {
  return "/.auth/login/aad?post_login_redirect_uri=" + encodeURIComponent(redirectPath);
}